import { BaseFilters } from '@/models/Service';
import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import LessonProgress from '@/models/LessonProgress';
import { SimpleLessonProgress } from '@/models/SimpleLessonProgress';
import { OrderingField } from '@/models/Filter';

export type LessonProgressOrderBy =
  | OrderingField<'scheduled_lesson_order'>
  | OrderingField<'lesson_order'>;

export type LessonProgressFilters = {
  lesson?: number[];
  lessonBlockId?: number[];
  studentId?: number[];
  klassId?: number;
  isActive?: boolean;
  courseProgressId?: number[];
  coursePathId?: number[];
  orderBy?: LessonProgressOrderBy;
  scheduledLessonOrderGt?: number;
  scheduledLessonActive?: boolean;
  lessonProgressId?: Array<number>;
  pending?: boolean;
} & BaseFilters;

export const listLessonProgressBySlugCourse = async (
  slugCourse?: string,
  params: LessonProgressFilters = {},
) => {
  const { data } = await requester().get<JsonApiResponse<LessonProgress>>(
    `course-progress/${slugCourse}/lessons/`,
    {
      params,
    },
  );

  return data;
};

export const updateLessonProgress = async ({
  lessonProgressId,
  lessonProgress,
}: {
  lessonProgressId: number;
  lessonProgress: Partial<LessonProgress>;
}) => {
  const { data: lessonProgressUpdated } =
    await requester().patch<LessonProgress>(
      `lesson-progress/${lessonProgressId}/`,
      lessonProgress,
    );
  return lessonProgressUpdated;
};

export const getLessonProgress = async (lessonProgressId: number) => {
  const { data } = await requester().get<LessonProgress>(
    `lesson-progress/${lessonProgressId}/`,
  );
  return data;
};

export const listLessonProgress = async (params: LessonProgressFilters) => {
  const { data } = await requester().get<JsonApiResponse<LessonProgress>>(
    'lesson-progress/',
    {
      params,
    },
  );
  return data;
};

export const listSimpleLessonProgress = async (
  params: LessonProgressFilters,
) => {
  const { data } = await requester().get<JsonApiResponse<SimpleLessonProgress>>(
    'lesson-progress/short-view/',
    {
      params,
    },
  );
  return data;
};

export const getSimpleLessonProgress = async (lessonProgressId: number) => {
  const { data } = await requester().get<SimpleLessonProgress>(
    `lesson-progress/short-view/${lessonProgressId}/`,
  );
  return data;
};
